import { render, staticRenderFns } from "./DisplaySkills.vue?vue&type=template&id=52a94c80&scoped=true"
import script from "./DisplaySkills.vue?vue&type=script&lang=js"
export * from "./DisplaySkills.vue?vue&type=script&lang=js"
import style0 from "./DisplaySkills.vue?vue&type=style&index=0&id=52a94c80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a94c80",
  null
  
)

export default component.exports